import ResetPassword from "./ResetPassword.presenter";
export default ResetPassword;
